import { UserManager, Log } from "oidc-client";

export default class OidcAuthService {
  manager = null;
  user = null;
  config = null;
  metaData = null;

  constructor(url, tenantName, oidcConfig = {}) {
    this.config = this.getClientSettings(url, tenantName, oidcConfig);
    this.metaData = this.getMetaData(url);

    this.manager = new UserManager({
      ...this.config,
      metadata: { ...this.metaData },
    });
    Log.logger = console;
    Log.level = Log.DEBUG;

    this.manager.getUser().then((user) => {
      this.user = user;
    });
  }

  isLoggedIn() {
    return this.user != null && !this.user.expired;
  }
  //Need to refactor this code once IDP configuration is finalzed
  getClientSettings(url, tenantName, oidcConfig = {}) {
    // 1. Priority check for custom configuration (Isolated for Hexaware SSO)
    if (oidcConfig && Object.keys(oidcConfig).length > 0) {
      return {
        authority: url + (url?.includes(`b2c`) ? "/" : ""),
        client_id: oidcConfig.client_id || "61afd809-9c44-4e3f-b691-1d6466d35f48",
        client_secret: "ZwR8Q~EdtCQV7m~nnXym46YiZZFqqJVt_KuctaUG",
        redirect_uri: oidcConfig.redirect_uri || (process.env.REACT_APP_API_ENDPOINT
          ? `${process.env.REACT_APP_API_ENDPOINT}/standBy`
          : window.location.hostname === "localhost" ? "http://localhost:3000/standBy" : "https://dev.makemylabs.in/standBy"),
        post_logout_redirect_uri: process.env.REACT_APP_API_ENDPOINT
          ? `${process.env.REACT_APP_API_ENDPOINT}`
          : window.location.hostname === "localhost" ? "http://localhost:3000/" : "https://dev.makemylabs.in",
        response_type: oidcConfig.response_type || "code",
        response_mode: oidcConfig.usePkce === false ? "query" : undefined,
        scope: oidcConfig.scope || "openid profile default-api offline_access",
        state: oidcConfig.state, // Allow manual state override
        filterProtocolClaims: true,
        loadUserInfo: oidcConfig.loadUserInfo !== undefined ? oidcConfig.loadUserInfo : true,
        extraQueryParams: {
          tenantName: tenantName,
          ...(oidcConfig.acr_values ? { acr_values: oidcConfig.acr_values } : {})
        },
      };
    }

    // 2. ORGINAL B2C FLOW (UNTOUCHED)
    if (url?.includes(`b2c`)) {
      return {
        authority: url + "/",
        client_id: "3e9af809-6316-4ec5-8921-676b93ea336c",
        client_secret: "#e$aurp9BFGHAMU^vUrVr95D",
        redirect_uri: process.env.REACT_APP_API_ENDPOINT
          ? `${process.env.REACT_APP_API_ENDPOINT}/standBy`
          : "https://dev.makemylabs.in/standBy",
        post_logout_redirect_uri: process.env.REACT_APP_API_ENDPOINT
          ? `${process.env.REACT_APP_API_ENDPOINT}`
          : "https://dev.makemylabs.in/",
        response_type: "code",
        scope: "openid profile default-api offline_access",
        filterProtocolClaims: true,
        loadUserInfo: true,
        extraQueryParams: { tenantName: tenantName },
      };
    } else {
      // 3. ORIGINAL DEFAULT FLOW (UNTOUCHED)
      return {
        authority: url,
        client_id: "3e9af809-6316-4ec5-8921-676b93ea336c",
        client_secret: "#e$aurp9BFGHAMU^vUrVr95D",
        redirect_uri: process.env.REACT_APP_API_ENDPOINT
          ? `${process.env.REACT_APP_API_ENDPOINT}/standBy`
          : "http://localhost:3000/standBy",
        post_logout_redirect_uri: process.env.REACT_APP_API_ENDPOINT
          ? `${process.env.REACT_APP_API_ENDPOINT}`
          : "http://localhost:3000",
        response_type: "code",
        scope: "openid profile default-api offline_access",
        filterProtocolClaims: true,
        loadUserInfo: true,
        extraQueryParams: { tenantName: tenantName },
      };
    }
  }

  getMetaData(url) {
    return {
      issuer: url,
      jwks_uri: `${url}/.well-known/openid-configuration/jwks`,
      authorization_endpoint: `${url}/connect/authorize`,
      token_endpoint: `${url}/connect/token`,
      userinfo_endpoint: `${url}/connect/userinfo`,
      end_session_endpoint: `${url}/connect/endsession`,
      check_session_iframe: `${url}/connect/checksession`,
      revocation_endpoint: `${url}/connect/revocation`,
      introspection_endpoint: `${url}/connect/introspect`,
      device_authorization_endpoint: `${url}/connect/deviceauthorization`,
      frontchannel_logout_supported: true,
      frontchannel_logout_session_supported: true,
      backchannel_logout_supported: true,
      backchannel_logout_session_supported: true,
      scopes_supported: [
        "openid",
        "profile",
        "email",
        "phone",
        "default-api",
        "offline_access",
      ],
      claims_supported: [
        "sub",
        "name",
        "family_name",
        "given_name",
        "middle_name",
        "nickname",
        "preferred_username",
        "profile",
        "picture",
        "website",
        "gender",
        "birthdate",
        "zoneinfo",
        "locale",
        "updated_at",
        "email",
        "email_verified",
        "phone_number",
        "phone_number_verified",
        "role",
      ],
      grant_types_supported: [
        "authorization_code",
        "client_credentials",
        "refresh_token",
        "implicit",
        "password",
        "urn:ietf:params:oauth:grant-type:device_code",
      ],
      response_types_supported: [
        "code",
        "token",
        "id_token",
        "id_token token",
        "code id_token",
        "code token",
        "code id_token token",
      ],
      response_modes_supported: ["form_post", "query", "fragment"],
      token_endpoint_auth_methods_supported: [
        "client_secret_basic",
        "client_secret_post",
      ],
      subject_types_supported: ["public"],
      id_token_signing_alg_values_supported: ["RS256"],
      code_challenge_methods_supported: ["plain", "S256"],
    };
  }

  getClaims() {
    return this?.user?.profile;
  }

  getAuthorizationHeaderValue() {
    return `${this?.user?.token_type} ${this?.user?.access_token}`;
  }

  startAuthentication() {
    return this?.manager?.signinRedirect();
  }

  completeAuthentication() {
    return this.manager
      ?.signinRedirectCallback()
      .then((user) => {
        this.user = user;
        return this.user;
      })
      .catch((error) => {
        console.log(error);
      });
  }

  startLogOut() {
    return this?.manager?.signoutRedirect();
  }

  completeSignOut() {
    return this?.manager?.signoutRedirectCallback().then((data) => {
      console.log("data from logout", data);
    });
  }

  getUserData() {
    return this?.user && this?.user;
  }

  refreshAccessToken() {
    return this.manager
      .signinSilent()
      .then((user) => {
        return user;
      })
      .catch((err) => err);
  }

  signinSilentCallback = () => {
    this.manager.signinSilentCallback();
  };
}
